import { gql } from '@apollo/client';

export const UPDATE_SIDEBAR_ORDER = gql`
  mutation updateSidebarOrder($userId: String!, $sidebarSectionOrder: [String!]!) {
    updateFeedPreferences(
      userId: $userId
      preferences: { sidebarSectionOrder: $sidebarSectionOrder }
    ) {
      sidebarSectionOrder
      updatedAt
    }
  }
`;
